export const USER_ROLES = {
    ADMIN: 'admin',
    USER: 'user',
    AGENCY: 'agency',
    ACCOUNT: 'account',
};
export const IMAGE_GENERATION_DEFAULTS = {
    DESCRIPTION: '',
    NUMBER_OF_VARIATIONS: 1,
    PRESET: undefined,
};
export const MEDIA_LIBRARY_FOLDER_NAME = 'Content AI';
export const PENDO_MODULE_EVENT_NAME = {
    social_planner: 'Social Planner',
    blog: 'Blog',
    funnel: 'Funnels',
    website: 'Website',
    email_builder: 'Email Builder',
};
export const DEFAULT_FIELD_MAPPING_KEY = 'default';
export const CUSTOM_CONTENT_LENGTH = {
    MIN: 50,
    MAX: 900,
    DEFAULT: 120,
};
// TODO: Instead of hard coding set defaults from backend
export const DEFAULT_IMAGE_AI_STYLES = [
    {
        category: 'Digital Art',
        key: 'dreamlike',
        title: 'Dreamlike',
        src: 'https://storage.googleapis.com/crm-conversations-ai-production/imageAiPresets/dreamlike.png',
        id: '6452165ce9b4a4de20bd7ddd',
    },
    {
        category: 'Digital Art',
        key: 'animated',
        title: 'Animated',
        src: 'https://storage.googleapis.com/crm-conversations-ai-production/imageAiPresets/filmic.png',
        id: '64c8ed991a4ab25fd9fabaf1',
    },
    {
        category: 'Photography',
        key: 'photo',
        title: 'Photo',
        src: 'https://storage.googleapis.com/crm-conversations-ai-production/imageAiPresets/photo.png',
        id: '6452165ce9b4a4de20bd7dde',
    },
    {
        category: 'Digital Art',
        key: 'colorful',
        title: 'Colorful',
        src: 'https://storage.googleapis.com/crm-conversations-ai-production/imageAiPresets/colorful.png',
        id: '6452165ee9b4a4de20bd7de3',
    },
    {
        category: 'Fine Art',
        key: 'watercolor',
        title: 'Watercolor',
        src: 'https://storage.googleapis.com/crm-conversations-ai-production/imageAiPresets/watercolor.png',
        id: '6452165de9b4a4de20bd7ddf',
    },
];
// TODO: Instead of hard coding set order from backend
export const STYLE_CATEGORY_ORDER = ['Photography', 'Digital Art', 'Fine Art'];
